<mat-dialog-content class="custom-modal-container">
  <h5 class="text-center text-title-modal" mat-dialog-title>
    Information Banks
  </h5>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div *ngIf="loading" class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div *ngIf="!loading" class="table-responsive">
            <table class="table table-hover">
              <thead class="text-primary">
                <tr>
                  <th>Name</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Comment</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let bank of data">
                  <td>
                    <p>
                      {{ bank.bankName | capitalizeInitialsPipe }}
                    </p>
                  </td>
                  <td>
                    <span>
                      {{ bank.amount | currency: 'USD' }}
                    </span>
                  </td>
                  <td>
                    <span class="badge badge-success">
                      {{ bank.status }}
                    </span>
                  </td>
                  <td>
                    <span>
                      {{ bank?.comment }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <mat-dialog-actions class="text-black-50 justify-content-center">
    <button
      (click)="close()"
      class="btn btn-block btn-sm btn-info text-white"
      mat-button
    >
      Close
    </button>
  </mat-dialog-actions>
</mat-dialog-content>
